import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useGetEmails, useUserInput } from '@store';

interface ChangeEmailHelperOutput {
	resources: ChangeEmailHelperResources;
	titleLabel: string;
}

interface ChangeEmailHelperResources {
	titleAllMethods: string;
	titleAtmMbway: string;
	description: string;
}

export const useChangeEmailHelper = (): ChangeEmailHelperOutput => {
	const t = useTranslation();
	const emails = useGetEmails();
	const { acceptMasterOrVisaCards } = useUserInput();

	const resources: ChangeEmailHelperResources = {
		titleAllMethods: t('placeholder.resume.changeEmailCard.title.allMethods'),
		titleAtmMbway: t('placeholder.resume.changeEmailCard.title.atmMbway'),
		description: t('placeholder.resume.changeEmailCard.description', {
			email: emails[0],
			email2: emails[1],
		}),
	};

	const titleLabel = acceptMasterOrVisaCards ? resources.titleAllMethods : resources.titleAtmMbway;

	return { resources, titleLabel };
};
